export default "__VITE_ASSET__DnknvaDg__"